import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme: any) => {
  return {
    container: {
      margin: '0px auto',
      height: "calc(100% - 250px)",
      width: "100%",
    },
    headerModal: {
      backgroundColor: "#FFF",
      padding: '16px 24px 11px',
      display: 'flex',
      justifyContent: 'space-between',
      borderRadius: '0px 0px 8px 8px',
      height: '100px',
      position: "sticky",
      top: 0
    },
    titleModal: {
      font: theme.custom.font.montserrat16,
      '& p:first-child': {
        font: 'normal normal 700 16px/32px Montserrat',
      },
      '& p': {
        font: theme.custom.font.paragraph2,
        color: theme.custom.colors.primary,
      }
    },
    fontMon16: {
      font: theme.custom.font.paragraph3,
      color: '#000'
    },
    dFlexRight: {
      display: 'flex',
      alignItems: 'center',
      // marginTop: 15
    },
    btnAddExerciseHeader: {
      color: theme.custom.colors.purple,
      font: 'normal normal 700 14px/18px Montserrat',
      cursor: 'pointer'
    },
    wrapSearch: {
      display: 'flex',
      border: `1px solid ${theme.custom.colors.borderGrey}`,
      borderRadius: '30px',
      height: 32,
      width: 260,
      maxWidth: '100%',
      paddingLeft: 10,
      alignItems: 'center',
      marginLeft: 16,
      '& span': {
        display: 'inline-block',
        cursor: 'pointer',
        width: 30,
        textAlign: 'center',
        paddingTop: 4,
      },
      '& input': {
        border: 'none',
        font: `400 14px/16px "Public-Sans"`,
        height: 30,
        borderRadius: '30px',
        flex: 1,
        padding: '0 20px 0 5px',
        '&:focus': {
          outline: 'none'
        }
      }
    },
    bodyModal: {
      padding: '24px 47px',
    },
    bodyModalList: {
      overflowY: 'scroll',
      padding: '24px 47px'
    },
    fixedHeightList: {
      height: "700px"
    },
    noExercise: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column',
      font: theme.custom.font.montserrat16,
      '& img': {
        marginBottom: 24
      },
    },
    btnAddExerciseBody: {
      marginTop: 16,
      '& button': {
        height: 32,
        background: theme.custom.colors.primary,
        fontWeight: 'bold',
        color: theme.custom.colors.white,
        fontSize: theme.custom.fontSize.size16,
        fontFamily: theme.custom.fontFamily.title,
        boxShadow: 'none',
        textTransform: 'inherit',
        borderRadius: '30px',
        '&:hover': {
          background: theme.custom.colors.primary,
        },
      },
    },
    styleLoadingPage: {
      width: '100%',
      height: "700px",
      textAlign: 'center',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    listExercises: {
      display: 'grid',
      gridRowGap: 24,
      gridTemplateColumns: 'repeat(2, 50%)',
      // minHeight: 300,
      // alignItems: 'flex-start',
      // maxHeight: 400,
    },
    itemExercise: {
      display: 'flex',
      border: `1px solid ${theme.custom.colors.borderGrey}`,
      boxShadow: '1px 1px 6px rgba(56, 25, 81, 0.25)',
      borderRadius: 10,
      cursor: 'pointer',
      padding: 8,
      height: 102,
      // width: 440,
      maxWidth: '100%',
      marginRight: 24,
      '& img': {
        objectFit: 'contain',
        maxWidth: 120,
      },
      '&:nth-child(2n)': {
        marginRight: 0,
      },
      '&.active': {
        border: `1px solid #0C85F4`,
      }
    },
    contentExercise: {
      minWidth: 'calc(100% - 116px)',
      padding: '10px 17px',
      font: theme.custom.font.montserrat14,
      color: theme.custom.colors.midGray,
    },
    titleExercise: {
      font: theme.custom.font.montserrat16,
      color: theme.custom.colors.primary,
      display: '-webkit-box',
      overflow: 'hidden',
      '-webkit-line-clamp': 1,
      '-webkit-box-orient': 'vertical'
    },
    subTitle: {
      display: '-webkit-box',
      overflow: 'hidden',
      '-webkit-line-clamp': 2,
      '-webkit-box-orient': 'vertical'
    },
    footerModal: {
      height: '12.4%',
      padding: '16px 24px',
      display: 'flex',
      boxShadow: '1px 1px 6px rgba(56, 25, 81, 0.25)',
      justifyContent: 'flex-end',
      alignItems: 'center',
      font: 'normal normal 500 16px/24px Public-Sans',
      '& div:first-child': {
        marginRight: 24,
        cursor: 'pointer',
      }
    },
    logoIconLoadmore: {
      width: 24,
      height: 24,
      objectFit: 'contain',
      animation: '$spin 2s linear infinite',
      '& img': {
        width: 24,
        height: 24,
      },
    },
    '@keyframes spin': {
      '0%': { transform: 'rotate(0deg)' },
      '100%': { transform: 'rotate(360deg)' },
    },
    viewIconLoadmore: {
      width: '100%',
      marginTop: '20px',
      justifyContent: 'center',
      display: 'flex',
    },
    tab: {
      display: "flex",
      flexDirection: "row",
      height: "50px",
      justifyContent: "center",
      alignItems: "center",
    },
    tabLabel: {
      fontFamily: "Montserrat",
      fontSize: "14px",
      padding: "10px",
      fontWeight: 600,
      justifyContent: "center",
      alignItems: "center",
      textAlign: "center",
      '&:hover': {
          backgroundColor: '#EDF3FA',
          borderRadius: "50px",
          color: " #0C85F4",
          cursor: "pointer",
      },
      marginRight: "10px",
    },
    tabLabelSelected: {
      fontFamily: "Montserrat",
      fontSize: "14px",
      fontWeight: 600,
      padding: "10px",
      lineHeight: "17px",
      letterSpacing: "0em",
      textAlign: "center",
      color: "#0C85F4",
      backgroundColor: "#EDF3FA",
      justifyContent: "center",
      alignItems: "center",
      borderRadius: 20,
      marginRight: "10px"
    }
  };
});

export default useStyles;
